// extracted by mini-css-extract-plugin
export default {"tag":"_1ov4T","monetizationDark1":"X4rZk","tagImg":"hB2vo","tagText":"rbYRN","tagTitle":"_1dlE1","description":"_1IW1l","textCross":"_3QchF"};